import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=6efe16f6&"
import script from "./CreateTag.vue?vue&type=script&lang=js&"
export * from "./CreateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports